import React, { Component } from 'react';

/**
 * AJB Card Title
 */
export interface CardTitleProps
{
	size?: "l" | "m" | "s"
	tag?: "span" | "p" | "div"
	classnames?: string,
	children?: any
}

export class CardTitle extends Component<CardTitleProps>
{
	static defaultProps = {
		size: "m",
		tag: "span"
	};

	render()
	{
		const className = `ajb-card-title--${this.props.size} ${this.props.classnames ?? ''}`;
		switch ( this.props.tag ) {
			case "span":
				return (
					<span className={className}>
						{this.props.children}
					</span>
				);
			case "p":
				return (
					<p className={className}>
						{this.props.children}
					</p>
				);
			case "div":
				return (
					<div className={className}>
						{this.props.children}
					</div>
				);
		}
	}
}

/**
 * AJB Card Content
 */
export interface CardContentProps
{
	classnames?: string,
	children?: any
}

export class CardContent extends Component<CardContentProps>
{
	render()
	{
		const className = `ajb-card-content ${this.props.classnames ?? ''}`;
		return(
			<div className={className}>
				{this.props.children}
			</div>
		);
	}
}

/**
 * AJB Card
 */
export interface CardProps
{
	asCols?: boolean
	extraClassnames?: string,
	children?: any
}

export default class Card extends Component<CardProps>
{
	static defaultProps = {
		asCols: false
	};

	render()
	{
		let className = `ajb-card${this.props.asCols ? ' ajb-grid-cols':''}`;
		if ( this.props.extraClassnames ) {
			className += ` ${this.props.extraClassnames}`;
		}
		return(
			<div className="ajb-col-12">
				<div className={className}>
					{this.props.children}
				</div>
			</div>
		);
	}
}